import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "company",
  listKey: "companies",
  itemKey: "company",
  getAll: types.GET_ALL_COMPANYS,
  getAllResponse: types.GET_ALL_COMPANYS_RESPONSE,
  getByIdResponse: types.GET_COMPANY_BY_ID_RESPONSE,
});
